import { render } from "./LearningDetail.vue?vue&type=template&id=18ab8be6"
import script from "./LearningDetail.vue?vue&type=script&lang=js"
export * from "./LearningDetail.vue?vue&type=script&lang=js"

import "./LearningDetail.vue?vue&type=style&index=0&id=18ab8be6&lang=css"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__